export const BOARD_WIDTH = 375
export const MOBILE_MAX_WIDTH = 500
